import React from 'react';
import styled from 'styled-components';
import { isColorDark } from 'src/dispensary-admin/customize/helpers';

type TabBarProps = {
  backgroundColor?: string | null;
  logo?: string | null;
};

const MenuIcon = (): JSX.Element => (
  <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect y='3' width='20' height='2' fill='currentColor' />
    <rect y='9' width='20' height='2' fill='currentColor' />
    <rect y='15' width='20' height='2' fill='currentColor' />
  </svg>
);

const valueOrDefault = (value: string | null | undefined, defaultValue: string): string =>
  value?.length ? value : defaultValue;

const MobileHeader = ({ backgroundColor, logo }: TabBarProps): JSX.Element => (
  <MobileHeaderContainer
    backgroundColor={valueOrDefault(backgroundColor, '#3387E1')}
    useLightText={isColorDark(valueOrDefault(backgroundColor, '#3387E1'))}
  >
    <MenuIcon />
    {!!logo?.length && (
      <Logo>
        <img src={logo} alt='Dispensary Name' />
      </Logo>
    )}
    {!logo?.length && <Name>Dispensary Name</Name>}
  </MobileHeaderContainer>
);

const MobileHeaderContainer = styled.div<{ backgroundColor: string; useLightText: boolean }>`
  align-items: center;
  background-color: ${({ backgroundColor }) => backgroundColor};
  color: ${({ useLightText }) => (useLightText ? '#ffffff' : '#000000')};
  display: flex;
  padding: 40px 16px 10px;
  width: 100%;

  > svg {
    margin-right: 15px;
  }
`;

const Name = styled.div`
  font-size: 16px;
  font-weight: bold;
`;

const Logo = styled.div`
  flex: 1 0 0px;
  text-align: center;

  img {
    margin-left: -30px;
    max-height: 34px;
    width: auto;
  }
`;

export default MobileHeader;
